import useStyles from './styles';

export function Spacer() {
  const classes = useStyles();
  return <div className={classes.space} />;
}

export default Spacer;
